module.exports = __webpack_public_path__ + "/afcd650cfd53aa4a7bd478d6af74bbc3.png";